import {
  useQuery,
  useQueryClient,
  useMutation
} from '@tanstack/react-query'

import { buildResourcefulRequests } from '@utils/requests'

export function useScenarioListQuery({
  clientId,
  initialData,
  queryKey
}) {
  const basePath = `/api/scenarios`
  const scenarioRequests = buildResourcefulRequests(basePath)
  const queryClient = useQueryClient()
  const indexSearchParams = new URLSearchParams({ client_id: clientId })

  const scenarioQuery = useQuery({
    queryFn: () => scenarioRequests.index(indexSearchParams.toString()),
    queryKey,
    initialData
  })

  const updateScenarioMutation = useMutation({
    mutationFn: scenarioRequests.update,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKey]
      })
    }
  })

  const isFetching = scenarioQuery.isFetching

  const isAnyLoading = scenarioQuery.isFetching ||
    updateScenarioMutation.isLoading

  return {
    data: scenarioQuery.data,
    status: scenarioQuery.status,

    actions: {
      update: updateScenarioMutation.mutateAsync,
      refetch: scenarioQuery.refetch
    },

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
